module.exports = __webpack_public_path__ + "img/paypal-1.44e2aac4.svg";